module.exports = __webpack_public_path__ + "static/media/The-Meadows-Amendment-1.ee77f378.pdf";